import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAppOptionValueEquals } from "../../hooks/framework/useAppOptionValue";
import { LoadingIndicator } from "./loadingIndicator";

interface OptionGuardProps {
    code: string;
    children: ReactNode;
    redirectTo?: string;
}

export const OptionGuard = ({
    code,
    children,
    redirectTo = "/",
}: OptionGuardProps) => {
    const [enabled, loading] = useAppOptionValueEquals(code, true);

    if (loading) {
        return <LoadingIndicator />;
    }

    if (!enabled) {
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
};
